module.exports = __webpack_public_path__ + "img/ng-background-blue.de3d1487.png";